import React from 'react';

import Accordion from '../../components/Accordion';
import { getCompanyList } from './getCompanies';

const OpeningHours = () => {
  const { places } = drupalSettings;

  async function getCompanies(companies) {
    const companyList = await getCompanyList(companies);

    if (companyList) {
      return (
        <>
          {companyList}
          <a className="opening-hours-list__top-link" href="#main-content">
            {Drupal.t(drupalSettings.page_top_text)}
          </a>
        </>
      );
    }

    return <></>;
  }

  return (
    <div className="opening-hours-list">
      <div className="accordion-list">
        {places && places.length > 0 ? (
          places.map((place, i) => (
            <div key={i} className="accordion-list__item">
              <Accordion
                fetchContent={() => getCompanies(place.companies)}
                title={<h3>{place.title}</h3>}
              />
            </div>
          ))
        ) : (
          <h3>{Drupal.t('Info not available.')}</h3>
        )}
      </div>
    </div>
  );
};

export default OpeningHours;
